<div class="card group card alternative no-border mat-elevation-z2" fxLayout="column" fxLayoutGap="24px">
  <div class="group-title">Material List</div>
  <div class="divider reverse"></div>
  <div class="section" fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="start stretch" fxLayoutAlign.gt-md="start start" fxLayoutGap="16px" fxLayoutGap.gt-md="24px">
    <div fxFlex.gt-md>
      <div fxLayout="column">
        <div class="section-title">Two-Line List with Avatars</div>
        <div class="section-tag">&lt;mat-list&gt;</div>
        <p>Lists are made up of a continuous column of rows. Each row contains a tile. Primary actions fill the tile, and supplemental actions are represented by icons and text.</p>
        <div class="section-info">Example:</div>
        <code vrHighlight class="html">&lt;mat-list&gt;<br/>  &lt;mat-list-item&gt;<br/>    &lt;img mat-list-avatar src="avatar.png"&gt;<br/>    &lt;h3 matLine&gt;John&lt;/h3&gt;<br/>    &lt;p matLine&gt;Brunch?&lt;/p&gt;<br/>  &lt;mat-list-item&gt;<br/>&lt;/mat-list&gt;</code>
      </div>
    </div>
    <mat-tab-group class="preview-tabs mat-elevation-z2" fxFlex="auto" fxFlex.gt-md="70%">
      <mat-tab label="PREVIEW">
        <div class="preview" fxLayout="row" fxLayoutAlign="center center">
          <mat-list class="demo-list mat-elevation-z2">
            <mat-list-item>
              <img mat-list-avatar src="assets/img/demo/avatars/1.png">
              <h3 matLine>John</h3>
              <p matLine>
                <span>Brunch?</span>
                <span class="subline">-- Did you want to go on Sunday? I was thinking</span>
              </p>
            </mat-list-item>
            <mat-list-item>
              <img mat-list-avatar src="assets/img/demo/avatars/2.png">
              <h3 matLine>Peter</h3>
              <p matLine>
                <span>Summer BBQ</span>
                <span class="subline">-- Wish I could come, but I have some special</span>
              </p>
            </mat-list-item>
            <mat-list-item>
              <img mat-list-avatar src="assets/img/demo/avatars/3.png">
              <h3 matLine>Nancy</h3>
              <p matLine>
                <span>Oui oui</span>
                <span class="subline">-- Have you booked the Paris trip?</span>
              </p>
            </mat-list-item>
          </mat-list>
        </div>
      </mat-tab>
      <mat-tab label="HTML">
        <code [innerHTML]="twoLineListHTML" vrHighlight class="html"></code>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="divider reverse"></div>

  <div class="section" fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="start stretch" fxLayoutAlign.gt-md="start start" fxLayoutGap="16px" fxLayoutGap.gt-md="24px">
    <div fxFlex.gt-md>
      <div fxLayout="column">
        <div class="section-title">Three-Line List with Avatars</div>
        <p>Lists with three lines add extra content to distinguish your list-item.</p>
        <div class="section-info">Example:</div>
        <code vrHighlight class="html">&lt;mat-list&gt;<br/>  &lt;mat-list-item&gt;<br/>    &lt;img mat-list-avatar src="avatar.png"&gt;<br/>    &lt;h3 matLine&gt;John&lt;/h3&gt;<br/>    &lt;p matLine&gt;Brunch?&lt;/p&gt;<br/>    &lt;p matLine class="subline"&gt;<br/>      Did you want to go on Sunday?<br/>    &lt;/p&gt;<br/>  &lt;mat-list-item&gt;<br/>&lt;/mat-list&gt;</code>
      </div>
    </div>
    <mat-tab-group class="preview-tabs mat-elevation-z2" fxFlex="auto" fxFlex.gt-md="70%">
      <mat-tab label="PREVIEW">
        <div class="preview" fxLayout="row" fxLayoutAlign="center center">
          <mat-list class="demo-list mat-elevation-z2">
            <mat-list-item>
              <img mat-list-avatar src="assets/img/demo/avatars/1.png">
              <h3 matLine>John</h3>
              <p matLine>Brunch?</p>
              <p matLine class="subline">Did you want to go on Sunday? I was thinking</p>
            </mat-list-item>
            <mat-list-item>
              <img mat-list-avatar src="assets/img/demo/avatars/2.png">
              <h3 matLine>Peter</h3>
              <p matLine>Summer BBQ</p>
              <p matLine class="subline">Wish I could come, but I have some special</p>
            </mat-list-item>
            <mat-list-item>
              <img mat-list-avatar src="assets/img/demo/avatars/3.png">
              <h3 matLine>Nancy</h3>
              <p matLine>Oui oui</p>
              <p matLine class="subline">Have you booked the Paris trip?</p>
            </mat-list-item>
          </mat-list>
        </div>
      </mat-tab>
      <mat-tab label="HTML">
        <code [innerHTML]="threeLineListHTML" vrHighlight class="html"></code>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="divider reverse"></div>

  <div class="section" fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="start stretch" fxLayoutAlign.gt-md="start start" fxLayoutGap="16px" fxLayoutGap.gt-md="24px">
    <div fxFlex.gt-md fxLayout="column">
      <div class="section-title">Three-Line List</div>
      <mat-tab-group class="preview-tabs mat-elevation-z2" fxFlex="auto" fxFlex.gt-md="70%">
        <mat-tab label="PREVIEW">
          <div class="preview" fxLayout="row" fxLayoutAlign="center center">
            <mat-list class="demo-list mat-elevation-z2">
              <mat-list-item>
                <h3 matLine>John</h3>
                <p matLine>Brunch?</p>
                <p matLine class="subline">Did you want to go on Sunday? I was thinking</p>
              </mat-list-item>
              <mat-list-item>
                <h3 matLine>Peter</h3>
                <p matLine>Summer BBQ</p>
                <p matLine class="subline">Wish I could come, but I have some special</p>
              </mat-list-item>
              <mat-list-item>
                <h3 matLine>Nancy</h3>
                <p matLine>Oui oui</p>
                <p matLine class="subline">Have you booked the Paris trip?</p>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-tab>
        <mat-tab label="HTML">
          <code [innerHTML]="threeLineListWithoutAvatarsHTML" vrHighlight class="html"></code>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div fxFlex.gt-md fxLayout="column">
      <div class="section-title">One-Line List</div>
      <div class="preview-tabs mat-elevation-z2" fxFlex="auto" fxFlex.gt-md="70%">
        <mat-tab-group>
          <mat-tab label="PREVIEW">
            <div class="preview" fxLayout="row" fxLayoutAlign="center center">
              <mat-list class="demo-list mat-elevation-z2">
                <mat-list-item>
                  <h3 matLine>John</h3>
                </mat-list-item>
                <mat-list-item>
                  <h3 matLine>Peter</h3>
                </mat-list-item>
                <mat-list-item>
                  <h3 matLine>Nancy</h3>
                </mat-list-item>
              </mat-list>
            </div>
          </mat-tab>
          <mat-tab label="HTML">
            <code [innerHTML]="oneLineList" vrHighlight class="html"></code>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
